import React from 'react';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import { LegendItem } from '../LegendItem/LegendItem.esm.js';
import { currencyFormatter } from '../../utils/formatters.esm.js';
import { useBarChartLayoutStyles } from '../../utils/styles.esm.js';
import { useConfig } from '../../hooks/useConfig.esm.js';
import '../../hooks/useCurrency.esm.js';
import '../../hooks/useFilters.esm.js';
import '../../hooks/useGroups.esm.js';
import '../../hooks/useLoading.esm.js';
import '../../hooks/useScroll.esm.js';
import '../../hooks/useLastCompleteBillingDate.esm.js';

const BarChartLegend = (props) => {
  const { costStart, costEnd, options = {}, children } = props;
  const theme = useTheme();
  const classes = useBarChartLayoutStyles();
  const { baseCurrency } = useConfig();
  const data = Object.assign(
    {
      previousName: "Previous",
      previousFill: theme.palette.lightBlue,
      currentName: "Current",
      currentFill: theme.palette.darkBlue
    },
    options
  );
  return /* @__PURE__ */ React.createElement(Box, { className: classes.legend, display: "flex", flexDirection: "row" }, /* @__PURE__ */ React.createElement(Box, { marginRight: 2 }, /* @__PURE__ */ React.createElement(
    LegendItem,
    {
      title: data.previousName,
      markerColor: options.hideMarker ? void 0 : data.previousFill
    },
    currencyFormatter(baseCurrency).format(costStart)
  )), /* @__PURE__ */ React.createElement(Box, { marginRight: 2 }, /* @__PURE__ */ React.createElement(
    LegendItem,
    {
      title: data.currentName,
      markerColor: options.hideMarker ? void 0 : data.currentFill
    },
    currencyFormatter(baseCurrency).format(costEnd)
  )), children);
};

export { BarChartLegend };
//# sourceMappingURL=BarChartLegend.esm.js.map
